<style lang="scss">
.doctor-dialog {
  .v-input--switch .v-label {
    color: #9E9E9E;
  }

  .v-input--switch.v-input--is-label-active .v-label {
    color: #FF9800;
  }
}
</style>

<template>
  <v-dialog v-bind="$attrs" v-on="$listeners" max-width="500" content-class="doctor-dialog">
    <v-form ref="form" lazy-validation @submit.prevent="submit">
      <v-card>
        <v-card-title class="headline"> {{ action }} Doctor </v-card-title>
        <v-card-text>
          <v-container class="white">
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="form.name"
                  label="Name"
                  validate-on-blur
                  maxlength="100"
                  :rules="nameRules"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.idNo"
                  label="ID Number"
                  maxlength="10"
                  validate-on-blur
                  :rules="IdNoRules"
                />
              </v-flex>
              <v-flex xs12>
                <v-switch
                  v-model="form.status"
                  false-value="1"
                  true-value="2"
                  label="排序"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
          <v-btn type="submit" color="blue darken-1" flat>Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

const DEFAULT = {
  name: '',
  idNo: '',
  status: '1',
}

export default {
  name: 'DoctorDialog',
  props: {
    current: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: this.gen(),
    }
  },
  computed: {
    formRef() {
      return this.$refs.form
    },
    isEdit() {
      return !!this.current
    },
    action() {
      return this.isEdit ? 'Edit' : 'Add'
    },
    nameRules(v) {
      return [!!v || '']
    },
    IdNoRules(v) {
      return [!!v || '']
    },
  },
  watch: {
    current(v) {
      if (v) {
        this.form = {
          doctorID: v.id,
          name: v.name,
          idNo: v.idNo,
          status: v.status,
        }
      } else {
        // 當切換為新增狀態時，重置表單
        this.form = this.gen()
      }
    },
    '$attrs.value'(v) {
      if (!v) {
        this.form = this.gen()
        this.formRef.resetValidation()
      }
    },
  },
  methods: {
    ...mapActions('doctors', ['addDoctor', 'updateDoctor']),
    gen() {
      // 產生全新的預設物件，避免被前次編輯污染
      return { ...DEFAULT }
    },
    submit() {
      if (this.formRef.validate()) {
        if (this.isEdit) {
          this.updateDoctor(this.form)
        } else {
          this.addDoctor(this.form)
        }
        this.close()
      }
    },
    close() {
      this.$emit('show', false)
    },
  },
}
</script>
